export default "<a href=\"javascript:void(0)\" (click)=\"onClick()\" class=\"text-red font-weight-bold\">{{ 'Export file' | translate }}</a>\n"